import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import posthog from 'posthog-js';
import { environment } from 'env/environment';

posthog.init(
  environment.postHogKey,
  {
    api_host: environment.postHogHost,
    person_profiles: 'always',
    defaults: '2025-05-24'
  }
)

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
